import React, { useState } from 'react';
import { Form, Checkbox, Card, Space, Typography, Select, Tooltip } from '../../../../../components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { SourceWorkerInputFields } from './SourceWorkerInputFields';
import { SourceWorkerNetworkConfig } from './SourceWorkerNetworkConfig';
import { VsphereEnvironmentCard } from './VsphereEnvironmentCard';
import { SourceWorkerTabs } from './SourceWorkerTabs';
import { ESTIMATED_PARALLEL_WORKLOADS_OPTIONS } from './helpers';
import './VMBasedMigrationsConfig.scss';

const { Title } = Typography;

export const VMBasedMigrationsConfig = ({ supportsMultipleSourceWorkers = false }) => {
    const form = Form.useFormInstance();
    const vmLevelEnabled = Form.useWatch('vmLevelEnabled', form);
    const sourceWorkersCount = Form.useWatch('sourceWorkersCount', form) || 1;
    const [activeWorkerKey, setActiveWorkerKey] = useState('1');

    return (
        <div className="form-section vm-based-migrations-config">
            <Title level={4}>Appliance Configuration</Title>

            <Form.Item name="useProxyEnabled" valuePropName="checked">
                <Checkbox>Use Migration Appliance as proxy during migrations</Checkbox>
            </Form.Item>

            <Form.Item name="vmLevelEnabled" valuePropName="checked">
                <Checkbox>Enable VM-based migrations</Checkbox>
            </Form.Item>

            {vmLevelEnabled && (
                <Space orientation="vertical" size="middle" className="vm-based-migrations-config__body">
                    <VsphereEnvironmentCard vmLevelEnabled={vmLevelEnabled} />

                    {supportsMultipleSourceWorkers ? (
                        <Card title="Source Worker Appliance Deployment" size="small" className="vm-config-card">
                            <Form.Item
                                name="sourceWorkersCount"
                                label={
                                    <span>
                                        Estimated Parallel Workloads{' '}
                                        <Tooltip title="Number of concurrent migration workloads. Each bucket dictates how many source worker appliances are deployed.">
                                            <QuestionCircleOutlined />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                <Select
                                    disabled={!vmLevelEnabled}
                                    options={ESTIMATED_PARALLEL_WORKLOADS_OPTIONS}
                                    onChange={(value) => {
                                        if (+value < +activeWorkerKey) {
                                            setActiveWorkerKey('1');
                                        }
                                    }}
                                />
                            </Form.Item>
                            <SourceWorkerTabs
                                workerCount={sourceWorkersCount}
                                activeKey={activeWorkerKey}
                                onChange={setActiveWorkerKey}
                                vmLevelEnabled={vmLevelEnabled}
                            />
                        </Card>
                    ) : (
                        <>
                            <Card title="Source Worker Appliance Deployment" size="small" className="vm-config-card">
                                <SourceWorkerInputFields sourceWorkerIndex={0} vmLevelEnabled={vmLevelEnabled} />
                            </Card>
                            <Card title="Network Configuration" size="small" className="vm-config-card">
                                <SourceWorkerNetworkConfig
                                    name={['sourceWorkers', 0, 'network']}
                                    disabled={!vmLevelEnabled}
                                />
                            </Card>
                        </>
                    )}
                </Space>
            )}
        </div>
    );
};

